export interface Vendor {
    _id: string;
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber?: string;
    email?: string;
    taxId?: string;
    notes?: string;
}

export interface Consignee {
    _id: string;
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber?: string;
}

export interface Purchaser {
    _id: string;
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber?: string;
}

export interface ManualEntity {
    name: string;
    address: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    country: string;
}

export interface ManualPart {
    id: string;
    partNumber: string;
    description?: string;
    hsCode?: string;
    countryOfOrigin?: string;
    quantity: number;
    unitPrice: number;
    usmca?: string;
    usmcaOriginCriteria?: string;
    usmcaQualificationMethod?: string;
}

export interface CCIFormData {
    vendorId: string;
    consigneeId: string;
    purchaserId: string;
    manualVendor: ManualEntity;
    manualConsignee: ManualEntity;
    manualPurchaser: ManualEntity;
    useManualVendor: boolean;
    useManualConsignee: boolean;
    useManualPurchaser: boolean;
    dateOfDirectShipment: string;
    currency: string;
    shipmentDetails: {
        transportation: string;
        otherReferences: string;
        countryOfTransshipment: string;
        conditionsOfSale: string;
        netWeight?: number;
        grossWeight?: number;
        weightUnit: string;
    };
    deductions: {
        transportationToCanada: string;
        constructionCosts: string;
        exportPackaging: string;
    };
    additions: {
        transportationToDirectJourney: string;
        commissions: string;
        exportPacking: string;
    };
    other: {
        royaltyPayments: boolean;
        suppliedGoods: boolean;
    },
    usmcaSignaturePermission: boolean
}

export interface DropdownOption {
    id: string;
    primaryText: string;
    secondaryText: string;
}

export const DRAFT_FORM_KEY = 'cci_form_draft';
export const DRAFT_PARTS_KEY = 'cci_parts_draft';
